export default "//static.tradera.net/touchweb/static/output/images/app-download-mobile-2x.79e7a2ec.png";